<!--
  PageTransBtn.vue
-->

<!-- -------------------------------------------------------------------------------- -->
<!-- template -->
<template>
  <div class="hm-display-mobile">

    <div :class="{'hm-hide': !memberPage}">
    <v-btn
      @click="onClickGroup"
      color="light-blue darken-4"
      dark
      small
      fixed
      bottom
      right
      fab
      style="margin-bottom: 60px;"
    >
      <v-icon>group</v-icon>
    </v-btn>
    <v-btn
      @click="onClickMap"
      color="light-blue darken-4"
      dark
      small
      fixed
      bottom
      right
      fab
    >
      <v-icon>place</v-icon>
    </v-btn>
    </div>

    <div :class="{'hm-hide': !groupPage}">
    <v-btn
      @click="onClickUser"
      color="light-blue darken-4"
      dark
      small
      fixed
      bottom
      right
      fab
      style="margin-bottom: 60px;"
    >
      <v-icon>person_pin</v-icon>
    </v-btn>
    <v-btn
      @click="onClickMap"
      color="light-blue darken-4"
      dark
      small
      fixed
      bottom
      right
      fab
    >
      <v-icon>place</v-icon>
    </v-btn>
    </div>

    <div :class="{'hm-hide': !mapPage}">
    <v-btn
      @click="onClickGroup"
      color="light-blue darken-4"
      dark
      small
      fixed
      bottom
      right
      fab
      style="margin-bottom: 60px;"
    >
      <v-icon>group</v-icon>
    </v-btn>
    <v-btn
      @click="onClickUser"
      color="light-blue darken-4"
      dark
      small
      fixed
      bottom
      right
      fab
    >
      <v-icon>person_pin</v-icon>
    </v-btn>
    </div>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { ROUTE_NAME, ROUTE_PATH } from '@/router/routes'

export default {
  name: 'PageTransBtn',
  data: () => ({
  }),
  mounted: function () {
    this.$log.debug('# PageTransBtn mounted.')
  },
  destroyed: function () {
    this.$log.debug('# PageTransBtn destoroyed.')
  },
  computed: {
    ...mapState({
      mCurrentPage: state => state.currentPage.sCurrentPage,
    }),
    memberPage: function () {
      return (this.mCurrentPage === 'member')
    },
    groupPage: function () {
      return (this.mCurrentPage === 'group')
    },
    mapPage: function () {
      return (this.mCurrentPage === 'map')
    },
  },
  watch: {
    /*
    mCurrentPage: function (current, previous) {
    },
    */
  },
  methods: {
    // -------------------------------------------------------------------------
    onClickMap: function () {
      this.$router.push(ROUTE_PATH.ROUTE_MAP_LOCATION)
      this.$store.commit('setUpbtnVisible', false)
      this.$store.dispatch('aChangeCurrentPage', 'map')
    },
    // -------------------------------------------------------------------------
    onClickUser: function () {
      this.$router.push({
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
        params: { id: this.$store.getters.loginUserId }
      })
      this.$store.commit('setUpbtnVisible', false)
      this.$store.dispatch('aChangeCurrentPage', 'member')
    },
    // -------------------------------------------------------------------------
    onClickGroup: function () {
      this.$router.push(ROUTE_PATH.ROUTE_WHEREABOUTS_LIST)
      this.$store.commit('setUpbtnVisible', false)
      this.$store.dispatch('aChangeCurrentPage', 'group')
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PageTransBtn.vue